import React from 'react'
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText
} from '@mui/material'
import {Controller, useFormContext} from 'react-hook-form'
import {resolve} from 'src/utils/utils'

interface Option {
  Id: number
  Description: string
}

interface FormSelectFieldProps {
  name: string
  label: string
  options: Option[]
}

const FormSelectField: React.FC<FormSelectFieldProps> = ({
  name,
  label,
  options
}) => {
  const {
    control,
    formState: {errors}
  } = useFormContext()

  const error = resolve(name, errors)

  return (
    <Controller
      control={control}
      name={name}
      render={({field: {onChange, value}}) => (
        <FormControl fullWidth error={!!error}>
          <InputLabel>{label}</InputLabel>
          <Select
            value={value}
            onChange={e => {
              onChange(e.target.value)
            }}
            label={label}
          >
            {options.map(option => (
              <MenuItem key={option.Id} value={option.Id}>
                {option.Description}
              </MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  )
}

export default FormSelectField
